import React, {Component} from 'react';
import './Summary.css';

class Summary extends Component {


    render() {
        return (

            <div id="summary" className="row home-block">

<div className="">
    <h1>In a Few Words</h1>

    <h5>
        Associate Professor in Computer Science at  
        <a target="_blank" href="https://www.univ-tlse3.fr/" rel="noopener noreferrer">  University of Toulouse Paul Sabatier
        </a>, working at the 
        <a target="_blank" href="https://www.irit.fr/" rel="noopener noreferrer"> I.R.I.T.</a> laboratory, 
        within the 
        <a target="_blank" href="https://www.irit.fr/en/departement/dep-artificial-intelligence/misfit-team/" rel="noopener noreferrer"> MISFIT (Machine Learning Integrity & Safety Fairness Impact Trust)</a> research group.
    </h5>

    <p>My main research interests include:</p>
    <ul>
        <li>Reinforcement learning</li>
        <li>Generative models</li>
        <li>Biais in IA</li>    
        <li>Time series analysis</li>
        <li>Recommender systems</li>
    </ul>

    <p>
        I have also taught AI, computer science and statistics at the 
        <a target="_blank" href="https://www.univ-tlse3.fr/" rel="noopener noreferrer">University of Toulouse Paul Sabatier</a>,
        the 
        <a target="_blank" href="http://www.unistra.fr/index.php?id=accueil&utm_source=unistra_fr&utm_medium=unistra_fr_homepage" rel="noopener noreferrer"> University of Strasbourg  </a>, 
        and at the engineering school 
        <a target="_blank" href="https://www.esiea.fr" rel="noopener noreferrer"> E.S.I.E.A</a>.
    </p>

    <p>
        Passionate about pedagogy and statistics, I use computer science and mathematics 
        to explore and better understand the world around us.
    </p>

    <p>
        For more information, feel free to contact me 
        <a href="mailto: emmanuelle.claeys@irit.fr"> by email</a>.
    </p>
</div>


            </div>

        );
    }
}

export default Summary;



// WEBPACK FOOTER //
// ./src/Components/Summary/Summary.js